import React from 'react';
import './styles.css';

function FilterSortControls({ sortOptions, setSortOption, setSearchTerm, fromIndexResults, toIndexResults, totalResults }) {
    return (
        <div className="filter-sort-section">
            <div className="search-sort-controls">
                <select onChange={e => setSortOption(e.target.value)}>
                    <option value="">Sort by...</option>
                    {sortOptions.map(option => (
                        <option key={option.value} value={option.value}>
                            {option.label}
                        </option>
                    ))}
                </select>
                <div className="a-size-base a-color-base">
                    {fromIndexResults}-{toIndexResults} of Total Results: {totalResults}
                </div>
                <input
                    type="text"
                    placeholder="Search..."
                    onChange={e => setSearchTerm(e.target.value)}
                />
            </div>
        </div>
    );
}

export default FilterSortControls;